import React, { useEffect, useState } from "react";
import Info from "./FurtherInformation.module.css";
import Button from "../../Component/Button/Button";
import { useForm } from "react-hook-form";
import { AddAddres, AddUser } from "../../Api/BarestServices";
import { useHistory } from "react-router-dom";
import { errorToast, succToast } from "../../Toast/Toast";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Select from "react-select";
import { GetVillageListApi } from "../../Api/ClientServices";

const FurtherInformation = (props) => {
  const [Address, setAddress] = useState();
  const [villages, setVillages] = useState();
  const [regionId, setRegionId] = useState("1");
  const [, setChooseFloor] = useState();
  const [floorValue, setFloorValue] = useState();
  const [disable, setDisable] = useState(false);
  let addressInfo = props.location.state;
  const [hasLift, setHasLift] = useState(
    addressInfo.elevator === "1" ? true : false
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  //////////floor data jason////////////////
  const floors = [
    {
      value: "-1",
      label: "زیرزمین",
    },
    {
      value: "0",
      label: "همکف",
    },
    {
      value: "1",
      label: "طبقه اول",
    },
    {
      value: "2",
      label: "طبقه دوم",
    },
    {
      value: "3",
      label: " طبقه سوم",
    },
    {
      value: "4",
      label: "طبقه چهارم",
    },
    {
      value: "5",
      label: "طبقه پنجم",
    },
    {
      value: "6",
      label: "طبقه ششم به بالا",
    },
  ];
  const changeFloor = (e) => {
    setChooseFloor(e.label);
    setFloorValue(e.value);
  };
  useEffect(() => {
    setAddress(localStorage.getItem("address_compact"));
    getVillageList(addressInfo.city_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const history = useHistory();
  const onSubmit = (data) => {
    // setDisable(true);
    let UserInfo = {
      first_name: data.name,
      last_name: data.lastname,
      email: data.email,
      referral:localStorage.getItem("ref") ===null
          ? data.refcode
          : localStorage.getItem("ref"),
    };
    localStorage.setItem("FirstName", data.name);
    AddUser(UserInfo, (succ, res) => {
      if (res.status === 1) {
        let UserAddress = {
          title: data.title,
          city_id: props.location.state.city_id,
          address: Address,
          lat: localStorage.getItem("lat"),
          lon: localStorage.getItem("lon"),
          // postalcode: data.postalcode,
          // district: data.district,
          street: data.street,
          alley: data.alley,
          apartment_name: data.apartmentname,
          apartment_number: data.vahed,
          plate: data.plate,
          phone: data.phone,
          description: data.describe,
          region_id: regionId,
          floor: floorValue,
          elevator: hasLift ? 1 : 0,
        };
        AddAddres(UserAddress, (succ, res) => {
          if (res.status === 1) {
            // localStorage.setItem("LName",data.lastname)
            succToast(res.message);
            setTimeout(function () {
              history.push("/");
            }, 2000);
          } else {
            errorToast(res.message);
            setDisable(false);
          }
        });
      } else {
        errorToast(res.message);
        setDisable(false);
      }
    });
  };

  ///////////////villages///////////
  const getVillageList = async (id) => {
    GetVillageListApi(id, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setVillages(res.regions);
        }
      } else {
        console.error(res);
      }
    });
  };
  let VillagesOption =
    villages &&
    villages.map((item) => {
      return { value: item.id, label: item.name };
    });
  const changeVillage = (e) => {
    setRegionId(e.value);
  };
  return (
    <div className={Info.container}>
      <BurgerMenuTitle title="اطلاعات" />
      <form onSubmit={handleSubmit(onSubmit)} className={Info.formHolder}>
        <div className={Info.svg}>
          <img src={"/Assets/Images/Info/Mask.png"} alt="اطلاعات کاربر" />
        </div>
        <section className={Info.inputPart}>
          <p className={Info.notice}>
            <span className={Info.sup}>*</span>وارد کردن موارد ستاره دار
            الزامیست<span className={Info.sup}>*</span>
          </p>
          <label className={Info.inputName}>
            نام<span className={Info.redColor}>*</span>
          </label>
          <input
            {...register("name", { required: true })}
            placeholder={"مثال:اصغر"}
            className={errors.name ? Info.valid : Info.text}
          />

          <label className={Info.inputName}>
            نام خانوادگی<span className={Info.redColor}>*</span>
          </label>
          <input
            {...register("lastname", { required: true })}
            placeholder={"مثال:اصغری"}
            className={errors.lastname ? Info.valid : Info.text}
          />
          {localStorage.getItem("ref") === "null" ||
          localStorage.getItem("ref") === null ? (
            <>
              <label className={Info.inputName}>کد معرف </label>
              <input
                {...register("refcode")}
                placeholder={"کد معرف خود را وارد کنید"}
                className={Info.text}
              />
            </>
          ) : null}
          <label className={Info.inputName}>
            خیابان <span className={Info.redColor}>*</span>
          </label>
          <input
            {...register("street", { required: true })}
            placeholder={"مثال: شهید منصوریان"}
            className={errors.street ? Info.valid : Info.text}
          />
          <label className={Info.inputName}>
            طبقه <span className={Info.redColor}>*</span>
          </label>
          <Select
            onChange={(e) => changeFloor(e)}
            options={floors}
            placeholder={" طبقه چندم"}
            className={Info.selectPart}
          />
          <div className={Info.liftHolder}>
            <input
              className={Info.checkInput}
              type={"checkbox"}
              onChange={(e) => setHasLift(e.target.checked)}
              checked={hasLift}
            />
            <label className={Info.inputName}>ساختمان آسانسور دارد</label>
          </div>
          <label className={Info.inputName}>
            روستا<span className={Info.redColor}>*</span>(در صورتی که ساکن شهر
            هستید گزینه مرکزی انتخاب شود){" "}
          </label>
          <Select
            onChange={(e) => changeVillage(e)}
            options={VillagesOption}
            placeholder={"روستا"}
            className={Info.selectPart}
            value={
              VillagesOption &&
              VillagesOption.filter((option) => option.value === regionId)
            }
          />
          <label className={Info.inputName}>ایمیل</label>
          <input {...register("email")} className={Info.text} type={"email"} />

          <label className={Info.inputName}>شماره تماسِ فردِ گیرنده</label>
          <input
            {...register("phone")}
            className={Info.text}
            placeholder={"اگر تحویل گیرنده شخص دیگری است "}
          />

          <label className={Info.inputName}>عنوان آدرس(مثال: منزل)</label>
          <input
            {...register("title")}
            placeholder={"مثال: محل کار"}
            className={Info.text}
          />

          <label className={Info.inputName}>کوچه</label>
          <input
            {...register("alley")}
            placeholder={"مثال: مهر"}
            className={Info.text}
          />

          <label className={Info.inputName}>پلاک</label>
          <input
            {...register("plate")}
            placeholder={"مثال: 14"}
            className={Info.text}
          />

          <label className={Info.inputName}>نام ساختمان </label>
          <input
            {...register("apartmentname")}
            placeholder={"مثال: مهر"}
            className={Info.text}
          />

          <label className={Info.inputName}>واحد</label>
          <input
            {...register("vahed")}
            placeholder={"مثال: 1"}
            className={Info.text}
          />

          <label className={Info.inputName}>توضیحات آدرس </label>
          <textarea
            placeholder="مثال: درب اول سمت چپ به رنگ سفید"
            {...register("describe")}
            className={Info.textArea}
          />
        </section>
        <div className={Info.ButtonHolder}>
          <Button
            Value={"تایید"}
            ClassBtn={"confrimBtn"}
            disabledprops={disable}
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

export default FurtherInformation;
